import { ref, watch } from "vue";

export function useDebounce(value, delay) {
  const debouncedValue = ref(value); // Initialize with the current value

  let timeout;
  watch(
    () => value, // Watch the reactive source
    (newValue) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        debouncedValue.value = newValue; // Update the debounced value
      }, delay);
    },
    { immediate: true, deep: true } // Ensure immediate and deep watching
  );

  return debouncedValue;
}